




































































































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import { TemplateParamsItem } from '@/store/settings/template_params/types';
import {Action, Getter} from 'vuex-class';
import { cloneDeep, isEqual } from "lodash";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';
import { SelectWings, DatePickerWings, InputWings } from "wings-ui-components";

@Component({components: {DatePickerWings, SelectWings, InputWings}})
export default class TemplateParam extends Vue {
  @Ref('validator') validator: any;

  @Action("getTemplateParamsItem") actionGetItem: any;
  @Action("saveTemplateParamsItem") actionSaveItem: any;
  @Action("deleteTemplateParamsItem") actionDeleteItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("actionLog") actionLog: any;

  @Getter("transports") transportsList: any;

  defaultItem(): TemplateParamsItem {
    return {
      name: '',
      type: 1,
      conditions: {
        string_min_length: 0,
        string_max_length: 255,
        number_min_value: 0,
        number_max_value: 1000,
        enum: []
      }
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};
  partnersList: any = [];

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.actionGetTransports();
    if (this.$route.params.id) {
      try {
        const data = await this.actionGetItem(this.$route.params.id)
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: 'success',
          object_type: "Additional template param",
          object_name: data.name
        }
        await this.actionLog(this.logObject)
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        if (this.item.partner_id) this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
      } catch(err) {
        await this.actionLog({...this.logObject, action_status: 'failed'})
      }
    }
  }

  back(): void {
    this.$router.push('/settings/template_params/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Additional template param",
            object_name: this.item.name,
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSaveItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Additional template param",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDeleteItem(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  addEnumValue() {
    this.item.conditions.enum?.push('');
  }

  removeEnumValue(index: number) {
    this.item.conditions.enum?.splice(index, 1);
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
};
